export const parseColumnData = (input) => {
  const DataList = input.DataList.sort((a, b) => (a.DisplayOrder - b.DisplayOrder));

  const keys = DataList.filter(x => x.Selected).map(x => x.DataField);
  const defaultKeys = DataList
    .filter(x => x.DefaultDisplayOrder)
    .sort((a, b) => a.DefaultDisplayOrder - b.DefaultDisplayOrder)
    .map(x => x.DataField);
  const keyPairs = DataList.reduce((o, key) => ({ ...o, [key.DataField]: key.Caption }), {});

  return { keys, keyPairs, defaultKeys };
};

export const makeApiBody = (keys) => {
  const DataList = keys.map(DataField => ({ DataField }));

  return { DataList };
};

export const renameKeys = (arrayObject, newKeys, index = false) => {
  const newArray = [];
  arrayObject.forEach((obj, item) => {
    const keyValues = Object.keys(obj).map((key, i) => ({ [newKeys[i] || key]: obj[key] }));
    const id = (index) ? { ID: item } : {};
    newArray.push(Object.assign(id, ...keyValues));
  });
  return newArray;
};



// WEBPACK FOOTER //
// ./src/helpers/key-pairs.js